const PREFIX = "sellavo-app-lock:";

/** LocalStorage-nyckel för valfritt biometriskt applås. */
export function appLockKey(userId: string): string {
  return `${PREFIX}${userId}`;
}

export function isAppLockEnabled(userId: string | null | undefined): boolean {
  if (!userId || typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(appLockKey(userId)) === "1";
  } catch {
    return false;
  }
}

export function setAppLockEnabled(userId: string, enabled: boolean): void {
  if (typeof window === "undefined") return;
  try {
    if (enabled) window.localStorage.setItem(appLockKey(userId), "1");
    else window.localStorage.removeItem(appLockKey(userId));
  } catch {
    /* fullt/minne spelar ingen roll – låset förblir bara av/på */
  }
}
